import { useContext } from 'react'

import { ConfigContext } from '@provider/FollowUpFornecedor/ConfigProvider'

import { IConfigContext } from '@base/@types/providers/FollowUpFornecedor/ConfigProvider'

export default function useFollowUpConfig(): IConfigContext {
  return useContext(ConfigContext)
}
